import React from 'react';

const Paint = () => {
  return (
    <iframe
      src="https://chowderman.github.io/xp-paint.html"
      className="w-full h-full"
      style={{
        border: 'none',
        display: 'block'
      }}
      title="XP Paint"
    />
  );
};

export default Paint;
